import { useRef } from 'react'

import { AllSchedulingMethods } from 'constants/meetings'
import { useFilters } from 'hooks/meetings/filters'

import { useLookupUuidsQuery } from '../../../api'

/** Default scheduling_methods when caller does not pass them (e.g. CRM contact feed). Show all types. */
const DEFAULT_SCHEDULING_METHODS = AllSchedulingMethods

export const useFilterParamsWithUuids = (defaultParams) => {
  const { getFilterParams } = useFilters()
  const paramsWithSchedulingDefault = {
    ...(defaultParams || {}),
    scheduling_methods: defaultParams?.scheduling_methods ?? DEFAULT_SCHEDULING_METHODS
  }
  const filterParams = getFilterParams(paramsWithSchedulingDefault)
  const { data: uuids } = useLookupUuidsQuery({ filters: filterParams })

  const merged = uuids ? { ...filterParams, ...uuids } : null

  // Stabilize the returned reference. getFilterParams() creates a new object on
  // every render (it reads live query-params), which would otherwise cascade
  // through filters → baseMeetings → setMeetings causing a re-render loop.
  // We only hand back a new reference when the content actually changes, and we
  // retain the last valid value during transient lookup refetches.
  const stableRef = useRef(merged)
  if (merged !== null) {
    const serialized = JSON.stringify(merged)
    if (serialized !== JSON.stringify(stableRef.current)) {
      stableRef.current = merged
    }
  }

  return stableRef.current
}
